import { render, staticRenderFns } from "./NotificationSent.vue?vue&type=template&id=4e0705b0"
import script from "./NotificationSent.vue?vue&type=script&lang=js"
export * from "./NotificationSent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports